import { RocheUIImage, RocheUIImageLoading, RocheUIImageRatio } from '@repo/roche-ui';
import React from 'react';
import { parseAssetSource } from '../../utils/asset';
import { SlottedImageDataType } from './types';

export const getImageOrVideo = (
  slottedImage: SlottedImageDataType[],
  ratio: RocheUIImageRatio,
  bleed: boolean = true,
  loading: RocheUIImageLoading = RocheUIImageLoading.LAZY,
) => {
  const imageElement = slottedImage?.[0];

  if (!imageElement) {
    return null;
  }

  const brightcoveID = imageElement?.brightcove_id;
  if (typeof brightcoveID === 'string' && brightcoveID.trim() !== '') {
    return <roche-image brightcove-id={brightcoveID} slot='image' bleed={bleed} ratio={ratio} />;
  }

  const imageSrc = imageElement?.src;
  if (imageSrc?.filename) {
    const altText = imageSrc.alt !== undefined && imageSrc.alt !== '' ? imageSrc.alt : imageElement.srcAltText;
    return (
      <RocheUIImage
        src={parseAssetSource(imageSrc.filename)}
        caption={imageSrc.title}
        copyright={imageSrc.copyright}
        alt={altText}
        ratio={ratio}
        bleed={bleed}
        loading={loading}
      />
    );
  }

  return null;
};
